import { TranslatableString } from "@rjsf/utils";
import localize from "ajv-i18n";
import type { ErrorObject } from "ajv";
import i18n from "i18next";

export function localizeJsonSchemaErrors(errors?: null | ErrorObject[]): void {
	if (i18n.language.startsWith("fi")) {
		localize.fi(errors);
	} else {
		localize.en(errors);
	}
}

export function translateJsonSchemaFormString(stringKey: TranslatableString, params: string[] = []): string {
	const translated = getJsonSchemaFormTranslation(stringKey);
	return params.reduce((value, param, index) => value.replaceAll(`%${index + 1}`, param), translated);
}

function getJsonSchemaFormTranslation(stringKey: TranslatableString): string {
	switch (stringKey) {
		case TranslatableString.ArrayItemTitle:
			return i18n.t("schema_array_item");
		case TranslatableString.MissingItems:
			return i18n.t("schema_missing_items");
		case TranslatableString.EmptyArray:
			return i18n.t("schema_empty_array");
		case TranslatableString.YesLabel:
			return i18n.t("yes");
		case TranslatableString.NoLabel:
			return i18n.t("no");
		case TranslatableString.CloseLabel:
			return i18n.t("close");
		case TranslatableString.ErrorsLabel:
			return i18n.t("schema_errors");
		case TranslatableString.NewStringDefault:
			return i18n.t("schema_new_value");
		case TranslatableString.AddButton:
			return i18n.t("add");
		case TranslatableString.AddItemButton:
			return i18n.t("schema_add_item");
		case TranslatableString.CopyButton:
			return i18n.t("copy");
		case TranslatableString.ExpandButton:
			return i18n.t("expand");
		case TranslatableString.MoveDownButton:
			return i18n.t("move_down");
		case TranslatableString.MoveUpButton:
			return i18n.t("move_up");
		case TranslatableString.RemoveButton:
			return i18n.t("remove");
		case TranslatableString.NowLabel:
			return i18n.t("schema_now");
		case TranslatableString.ClearLabel:
		case TranslatableString.ClearButton:
			return i18n.t("clear");
		case TranslatableString.AriaDateLabel:
			return i18n.t("select_date");
		case TranslatableString.PreviewLabel:
			return i18n.t("preview");
		case TranslatableString.DecrementAriaLabel:
			return i18n.t("schema_decrease_value");
		case TranslatableString.IncrementAriaLabel:
			return i18n.t("schema_increase_value");
		case TranslatableString.OptionalObjectAdd:
			return i18n.t("schema_optional_object_add");
		case TranslatableString.OptionalObjectRemove:
			return i18n.t("schema_optional_object_remove");
		case TranslatableString.OptionalObjectEmptyMsg:
			return i18n.t("schema_optional_object_empty");
		case TranslatableString.Type:
			return i18n.t("type");
		case TranslatableString.Value:
			return i18n.t("value");
		case TranslatableString.OptionPrefix:
			return i18n.t("schema_option");
		case TranslatableString.TitleOptionPrefix:
			return i18n.t("schema_named_option");
		case TranslatableString.KeyLabel:
			return i18n.t("schema_key");
		case TranslatableString.DeprecatedLabel:
			return i18n.t("schema_deprecated");
		default:
			return i18n.t("schema_unsupported_field");
	}
}
